export const IHS_SOURCE = "Ihs";
export const GDC_SOURCE = "Gdc";
export const SHALE_PROFILE_SOURCE = "Shaleprofile";
